import React, { Component } from 'react';

//import from prime react
import { Calendar } from 'primereact/calendar';

//moment js
import moment from "moment";

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";


/**
 Props:
    calendarNavigator = true/false //NOTE: if navigator is set to true, you must include a year range, otherwise it will set it to default current year -> -10 years + 30 years
    yearRange => "Year:Year"
    minDate => min date (inclusive) that is allowed to be clicked on the calendar
    maxDate => max date (inclusive) that is allowed to be clicked on the calendar
    showButtonBar => True/False to show clear and today button on bottom of calendar bar
    name => the name form posts
    placeholder => placeholder text
    className => class names
    inputClassName => input className style
    calendarIcon = true/false to show calendar icon
    disabled => true/false disables the calendar
    required => true/false sets the required input for this calendar
    numYearRangeBack => number of years shown backwards from today for range
    numYearRangeForward => number of years shown forwards from today for range
    value => value of text that is directly set and changes upon parent
    dateFormat => the format the date will be in ie: dd/mm/yyyy
*/

class DatePickerBox extends Component {

    state = {
        minYearsBack: (!isEmpty(this.props.numYearRangeBack) ? this.props.numYearRangeBack : 10),
        maxYearsForward: (!isEmpty(this.props.numYearRangeForward) ? this.props.numYearRangeForward : 30),
        required: (!isEmpty(this.props.required) ? this.props.required : false),
        focused: false,
    }

    constructor(props) {
        super(props);

        //bind functions
        this.getYearRange = this.getYearRange.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);

        //handles the empty class for required
        this.renderEmptyBorderClass = this.renderEmptyBorderClass.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);

        //helper functions
        this.convertDateStrToDateObject = this.convertDateStrToDateObject.bind(this);
    }

    //builds the year range to set date picker range
    getYearRange() {
        const thisYear = new Date().getFullYear();
        var yearRange = (thisYear - this.state.minYearsBack) + ":" + (thisYear + this.state.maxYearsForward);
        return yearRange;   
    }

    renderEmptyBorderClass() {
        //if required, not focused and the current value is empty, return the empty border class
        if (!isEmpty(this.props.disabled)
            && !this.props.disabled
            && this.state.required
            && isEmpty(this.props.value)
            && !this.state.focused
        ) {
            return "react_select_empty_border";
        }
        else {
            return "";
        }
    }

    //convert date string to a moment then to  a date
    convertDateStrToDateObject(dateStr) {
        if (!isEmpty(dateStr)) {
            return moment(dateStr).toDate();
        }
        else {
            return undefined;
        }
    }

    handleOnChange(event) {
        var currVal = event.target.value;
        var formattedDate = null;

        if(!isEmpty(currVal)) {
            //gurantee the date is fixed to YYYY MM DD format
            var momentDate = moment(currVal);
            //format moment date
            formattedDate = momentDate.format("YYYY-MM-DD");
        }
        
        //set the value at the parent if the set function exists
        if (this.props.onChangeSetParentState) {
            this.props.onChangeSetParentState(formattedDate, this.props.name);
        }
    }

    handleOnBlur() {
        //on blur, set focused to false
        this.setState({
            focused: false,
        });
    }

    handleOnFocus() {
        //if on focus, sets focused flag to true
        this.setState({
            focused: true,
        });
    }

    render() { 
        return (  
            <React.Fragment>
                <Calendar 
                    className={"input_box_format " + (!isEmpty(this.props.className) ? this.props.className : "") + " " + this.renderEmptyBorderClass()}
                    inputClassName={this.props.disabled ? "disabled_input_box_format ": "input_box_format " + (!isEmpty(this.props.inputClassName) ? this.props.inputClassName : "")} 
                    value={(!isEmpty(this.props.value) ? this.props.value : null)}
                    showIcon={(!isEmpty(this.props.calendarIcon) ? this.props.calendarIcon : (this.props.disabled? false: true))}
                    name={this.props.name} 
                    placeholder={this.props.placeholder }
                    monthNavigator={(!isEmpty(this.props.calendarNavigator) ? this.props.calendarNavigator : true)}
                    yearNavigator={(!isEmpty(this.props.calendarNavigator) ? this.props.calendarNavigator : true)}
                    yearRange={this.getYearRange()} 
                    minDate={this.convertDateStrToDateObject(this.props.minDate)}
                    maxDate={this.convertDateStrToDateObject(this.props.maxDate)}
                   
                    showButtonBar={(!isEmpty(this.props.showButtonBar) ? this.props.showButtonBar : true)}
                    
                    dateFormat={(!isEmpty(this.props.dateFormat) ? this.props.dateFormat : "yy-mm-dd")}
                    readOnlyInput={true}
                    disabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}

                    onChange={(e) => this.handleOnChange(e)}
                    onFocus={(e) => this.handleOnFocus(e)}
                    onBlur={(e) => this.handleOnBlur(e)}
                />
            </React.Fragment>
        );
    }
}
export default DatePickerBox;